import * as z from "zod";

const MONITORING_TABS = [
  "workflows",
  "access",
  "value",
  "ai",
  "connectors",
] as const;

export const monitoringTab = z.enum(MONITORING_TABS);

export type MonitoringTab = z.infer<typeof monitoringTab>;

export const monitoringNavSource = z.enum([
  "nav",
  "tab_switch",
  "deep_link",
  "redirect",
  "visibility_return",
]);

export type MonitoringNavSource = z.infer<typeof monitoringNavSource>;

/**
 * Carried on the mutations Monitoring shares with other surfaces so the
 * analytics stream can say which surface fired one: a firing that arrives
 * without it came from somewhere else, and is not Monitoring usage.
 */
export const monitoringAnalytics = z.object({
  visitId: z.string().max(64),
  tab: monitoringTab,
});

export type MonitoringAnalytics = z.infer<typeof monitoringAnalytics>;

export function monitoringAnalyticsProps(
  analytics: unknown
): Record<string, unknown> | null {
  const parsed = monitoringAnalytics.safeParse(analytics);
  if (!parsed.success) return null;
  return {
    monitoring_visit_id: parsed.data.visitId,
    tab: parsed.data.tab,
  };
}
